'use client';

import { observer } from 'mobx-react';
import Button from '~/components/commonUi/Button/Button';
import Fieldset from '~/components/commonUi/Fieldset';
import { getStore } from '~/mobx/AppStore';

const SlagPreview = () => {
    const { companyStore, generalSettingsStore } = getStore();

    const slag = companyStore.selectedCompany?.name;
    const selectedElection = generalSettingsStore.selectedElectionData?.name;

    const handleCreatePdfBollot = (showAll: boolean) => {
        // `showAll` for slag
        // eslint-disable-next-line no-console
        console.log('Lag PDF stemmeseddel clicked | showAll =', showAll);
    };

    return (
        <Fieldset title={`${slag} innstillinger`}>
            <div className="slag-settings flex">
                <div className="w-3/4 grid grid-cols-12 text-left">
                    <div className="col-span-3">S-Lag</div>
                    <div className="col-span-9">{`${slag} / ${selectedElection}`}</div>
                </div>
                <div className="w-1/4 flex items-center justify-between hidden">
                    <Button
                        extendedClassName={'text-[11.48px] h-full w-full lg:w-auto'}
                        btnText={'Lag PDF stemmeseddel'}
                        testId={'create-pdf-bollot-button'}
                        onClick={() => handleCreatePdfBollot(true)}
                    />
                </div>
            </div>
        </Fieldset>
    );
};

export default observer(SlagPreview);
